import React, { useEffect, useState } from "react";
import {
  composeDurationMinutes,
  formatMinutesForStorage,
  parseDurationMinutes,
  splitDurationMinutes,
} from "../utils/trainingDuration";
import "./DurationMinutesSecondsInput.css";

/**
 * Coach duration editor: minutes + seconds → fractional minutes string for API/DB.
 */
export default function DurationMinutesSecondsInput({
  value,
  onChange,
  disabled = false,
  readOnly = false,
  className = "",
  inputClassName = "",
  minTotalSeconds = 1,
  "aria-label": ariaLabel,
}) {
  const parsed = parseDurationMinutes(value);
  const parts = splitDurationMinutes(parsed);
  const [mins, setMins] = useState(String(parts.minutes));
  const [secs, setSecs] = useState(String(parts.seconds));

  useEffect(() => {
    const next = splitDurationMinutes(parseDurationMinutes(value));
    setMins(String(next.minutes));
    setSecs(String(next.seconds));
  }, [value]);

  const emit = (mRaw, sRaw) => {
    const m = mRaw === "" ? 0 : Number(mRaw);
    let s = sRaw === "" ? 0 : Number(sRaw);
    if (!Number.isFinite(m) || !Number.isFinite(s)) return;
    if (s > 59) s = 59;
    if (s < 0) s = 0;
    const total = composeDurationMinutes(m, s);
    const totalSec = Math.round(total * 60);
    if (totalSec <= 0) {
      onChange?.("");
      return;
    }
    if (totalSec < minTotalSeconds) return;
    onChange?.(formatMinutesForStorage(total));
  };

  const locked = disabled || readOnly;

  return (
    <span
      className={`dms-input ${className}`.trim()}
      aria-label={ariaLabel || "Duration"}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="number"
        inputMode="numeric"
        min={0}
        step={1}
        disabled={locked}
        readOnly={readOnly}
        className={`dms-input__field ${inputClassName}`.trim()}
        value={mins}
        aria-label="Minutes"
        onChange={(e) => {
          const next = e.target.value.replace(/[^\d]/g, "");
          setMins(next);
          emit(next, secs);
        }}
      />
      <span className="dms-input__unit" aria-hidden>
        m
      </span>
      <input
        type="number"
        inputMode="numeric"
        min={0}
        max={59}
        step={1}
        disabled={locked}
        readOnly={readOnly}
        className={`dms-input__field dms-input__field--sec ${inputClassName}`.trim()}
        value={secs}
        aria-label="Seconds"
        onChange={(e) => {
          const next = e.target.value.replace(/[^\d]/g, "");
          setSecs(next);
          emit(mins, next);
        }}
      />
      <span className="dms-input__unit" aria-hidden>
        s
      </span>
    </span>
  );
}
